module.exports = __webpack_public_path__ + "static/elementscreenshot-62d4a34e6455c871a33f7124a84ebba0.mp4";